import React from 'react'
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack'
import { makeStyles } from '@material-ui/core'

// incompatability in production browser with pdfjs so pull this from cdn
const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`
pdfjs.GlobalWorkerOptions.workerSrc = url

const useStyles = makeStyles(theme => ({
  body: {
    '& .react-pdf__Page': {
      padding: '20px',
      backgroundColor: '#e6e6e6',
    },
    '& .react-pdf__Page__canvas': {
      width: '100% !important',
      height: 'auto !important',
      margin: '0 auto',
      maxWidth: '400px',
    },
    '& .MuiTable-root': {
      backgroundColor: '#ffffff !important',
    },
  },
}))

const PDFPreview = ({ document }) => {
  const classes = useStyles()
  if (!document) return null
  return (
    <div className={classes.body}>
      <Document file={document}>
        <Page pageNumber={1} />
      </Document>
    </div>
  )
}

export default PDFPreview
